import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles } from '../core/style/gstheme';
import withGS from '../core/withGShoc';

const styles = Object.assign({}, globalStyles);

class AssociatedProjectInfo extends React.Component {

    render() {

        const { data, defaultLang, includeHeading } = this.props;

        return (
            <React.Fragment>
                <Typography
                    variant="body2"
                    data-test="associated-project-info"
                    style={{ marginTop: '20px', fontSize: '16px', fontWeight: 500 }}
                    >{
                        data._notAvailable ?
                            "Project Deleted or Not Available"
                            :
                            data.title[defaultLang]
                    }</Typography>
                {includeHeading &&
                    <div><Typography variant="caption">Global</Typography></div>
                }
            </React.Fragment>
        );
    }
}

AssociatedProjectInfo.defaultProps = {
    includeHeading: true
};

AssociatedProjectInfo.propTypes = {
    data: PropTypes.object.isRequired,
    includeHeading: PropTypes.bool,
    id: PropTypes.string.isRequired,
    defaultLang: PropTypes.string.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(withGS(AssociatedProjectInfo));